/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";

import BlogDetail from "./BlogDetail";

/* Render listing-detail app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<BlogDetail {...props} />, document.getElementById("react"));
}
render(window.reactProps);
